// src/utils/logger.js
import log from 'loglevel';
import axios from 'axios';
import api from "../utils/api"; // Import the API utility


// Set the log level based on the environment
if (process.env.NODE_ENV === 'production') {
  log.setLevel('error'); // Only log errors in production
} else {
  log.setLevel('debug'); // Log everything in development
}

// Store the original methodFactory function
const originalFactory = log.methodFactory;

log.methodFactory = function (methodName, logLevel, loggerName) {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);
  return function (...args) {
    rawMethod(...args);
    if (process.env.NODE_ENV !== 'production') {
      api.post('/logs', { level: methodName, message: args })
        .catch(error => {
          // handle error, possibly by logging to an external service
          rawMethod('Logging error:', error);
        });
    }
  };
};

// Apply the new methodFactory
log.setLevel(log.getLevel());

export default log;
